"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalMethodKeyCache = void 0;
var methodKeyCache_1 = require("./methodKeyCache");
exports.globalMethodKeyCache = methodKeyCache_1.default();
//# sourceMappingURL=globals.js.map